export default __webpack_public_path__ + "static/media/img-gt-mode-on-bg-na_en.0549f766.jpg";